import React from 'react';

const AdmirationIconSVGR = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='76' height='83' viewBox='0 0 76 83'>
    <g>
      <g>
        <path
          fill='#fff'
          d='M38 51.875c-2.798 0-5.067 2.323-5.067 5.188 0 2.864 2.27 5.187 5.067 5.187 2.798 0 5.067-2.323 5.067-5.188 0-2.864-2.265-5.187-5.067-5.187zm-3.8-27.234v18.156c0 2.203 1.71 3.89 3.8 3.89s3.8-1.742 3.8-3.89V24.64c0-2.14-1.694-3.891-3.8-3.891s-3.8 1.75-3.8 3.89zm3.576 53.038C22.155 71 5.196 49.828 5.196 19.245L37.737 5.39c.056-.018.126-.052.264-.07l32.674 13.75c0 35.385-21.42 53.79-32.898 58.61zM71.33 13.567L40.93.597C40.153.268 38.84 0 38 0c-.823 0-2.138.268-2.913.598l-30.4 12.97C1.85 14.765 0 17.605 0 20.604 0 62.444 30 83 37.857 83 46.091 83 76 62.218 76 20.604c0-2.999-1.852-5.84-4.67-7.037z'
        />
      </g>
    </g>
  </svg>
);

export default AdmirationIconSVGR;
